//配置全局访问接口地址
// let overallUrl = "https://htkja.htkjbd.com/api";
let overallUrl = "https://htkja.htkjbd.com/api";

 
let baseUrl = {
  overallUrl
}
export default baseUrl